import React from 'react';
import './FormSection.css'
import {ChevronRight, ChevronDown} from 'lucide-react'

export const FormSection = ({ title, color, collapsible, defaultCollapsed, forcedCollapsed, children }) => {
    const [collapsed, setCollapsed] = React.useState(defaultCollapsed)

    React.useEffect(() => {
        if (forcedCollapsed !== undefined) setCollapsed(forcedCollapsed)
    }, [forcedCollapsed])

    const titleColor = color || "rgb(97 97 97)"
    return (
        <div className="FormSection">
            {title && (
                <div
                    className="FormSection-header"
                    onClick={() => collapsible && setCollapsed(!collapsed)}
                >
                    <h4 style={{color: titleColor}}>{title}</h4>
                    {collapsible && (collapsed ? <ChevronRight size={17}/> : <ChevronDown size={17}/>)}
                </div>
            )}

            <div className={`FormSection-content ${collapsed ? 'collapsed' : 'expanded'}`}>
                <div className="FormSection-content-inner">
                    {children}
                </div>
            </div>
        </div>
    )
}
